import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
	facetSelected,
	facetToggled,
	updateDismissFiltersUrl,
	updateFacetNameToScrollTo,
} from '../../actions/lister-actions';
import { useIsSmallAndAbove } from '../../hooks/mediaQueries';
import { scrollToTopOfLister } from '../../utilities/lister-utilities';
import { Breakpoint } from '../../utilities/ui-utilities';
import Checkbox from './Checkbox';
import ColourSwatch from './ColourSwatch';
import RadioButton from './RadioButton';

export const FacetValue = ({
	facetTypeId,
	facetTypeHeader,
	facetTypePosition,
	facetValue,
	facetValuePosition,
	isMultiSelect,
	storeSelectedFacets,
	largeLayoutScrollToTop,
}) => {
	const dispatch = useDispatch();

	const { dismissFiltersUrl, pageTitle } = useSelector((state) => state);

	const isSmallAndAbove = useIsSmallAndAbove();

	const handleChange = (evt) => {
		evt.preventDefault();
		evt.stopPropagation();

		dispatch(facetToggled(facetValue, isSmallAndAbove));

		dispatch(updateFacetNameToScrollTo(facetTypeHeader));

		scrollToTopOfLister(largeLayoutScrollToTop);

		const facetData = {
			facetTypeHeader: facetTypeHeader,
			facetTypePosition: facetTypePosition,
			facetValue: facetValue,
			facetValuePosition: facetValuePosition,
			pageUrl: dismissFiltersUrl,
			pageTitle: pageTitle,
			storeSelectedFacets: storeSelectedFacets,
		};

		dispatch(facetSelected(facetData));

		if (isSmallAndAbove) {
			dispatch(updateDismissFiltersUrl(facetValue.Url));
		}
	};

	const facetValueProps = {
		facetValue: facetValue,
		facetTypeHeader: facetTypeHeader,
		handleChange: handleChange,
	};

	if (isMultiSelect) {
		if (facetTypeId === 'colour') {
			return (
				<React.Fragment>
					<Breakpoint.BelowSmallOnly>
						<Checkbox {...facetValueProps} />
					</Breakpoint.BelowSmallOnly>
					<Breakpoint.SmallAndAbove>
						<ColourSwatch {...facetValueProps} />
					</Breakpoint.SmallAndAbove>
				</React.Fragment>
			);
		}

		return <Checkbox {...facetValueProps} />;
	}

	return <RadioButton {...facetValueProps} />;
};

export default FacetValue;
